<template>
  <div>
    <table class="table table-hover" id="vue-generic-table">
      <thead :class="{ 'sticky-on-top': options && options.theadSticky }">
        <tr class="heading">
          <th v-if="options && options.actionColumnEnabled"></th>
          <th v-for="(label, index) in headerLabels" :key="index">{{ label }}</th>
        </tr>
      </thead>
      <tbody class="scroll">
        <tr v-for="(element, index1) in elements" :key="index1">
          <td
            v-if="options && (options.canDeleteRow || options.canOpenUrl || options.actionButtons.length > 0)"
            class="button-table-generic"
          >
            <button
              v-if="notDisableElement(element) && options.canOpenUrl && (!options.canOpenAttr || element[options.canOpenAttr])"
              type="button"
              class="btn btn-link no_border padding"
              @click="openUrl(element, index1)"
            >
              <i class="fa-light fa-pen pulsante_comando" :class="{ small: options.smallButtons }"></i>
            </button>
            <button
              v-else-if="options.canShowUrl && element && (!options.canShowAttr || element[options.canShowAttr])"
              type="button"
              class="btn btn-link no_border padding"
              @click="showUrl(element, index1)"
            >
              <i class="fa-light fa-eye pulsante_comando" :class="{ small: options.smallButtons }"></i>
            </button>
            <button
              v-if="notDisableElement(element) && options.canDeleteRow && (!options.canDeleteAttr || element[options.canDeleteAttr])"
              type="button"
              class="btn btn-link no_border padding"
              @click="removeElement(element, index1)"
            >
              <i class="fa-light fa-trash pulsante_comando" :class="{ small: options.smallButtons }"></i>
            </button>
            <component
              v-for="button in visibleActionButtons(element)"
              :key="button.cod"
              :is="button.component"
              :classImage="button.classImage"
              :type="button.eventType"
              :element="getElementForActionButton(element)"
              @clicked="(sel) => emitEvent(sel)"
            />
          </td>
          <template v-if="options && options.htmlContent">
            <td v-for="(key, index2) in getElements(element)" :key="index2" v-html="element[key]"></td>
          </template>
          <template v-else>
            <td v-for="(key, index2) in getElements(element)" :key="index2">
              {{ element[key] }}
            </td>
          </template>
        </tr>
      </tbody>
    </table>
    <infinite-loading
      force-use-infinite-wrapper="body"
      v-if="options && options.infiniteScrollEnable"
      @infinite="infiniteHandler"
      spinner="circles"
      ref="infiniteLoading"
    >
      <div slot="no-more"></div>
      <div slot="no-results"></div>
    </infinite-loading>
  </div>
</template>
<script>
import InfiniteLoading from 'vue-infinite-loading';

// Questo componente accetta in imput un array di oggetti javascript da visualizzare, un array di headers e uno di opzioni
// di convenzione il nome delle chiavi dell'oggetto javascript deve essere uguale al nome dell'header corrispondente
// options accetta i seguenti valori:
// actionColumnEnabled -> se true aggiunge una colonna in fondo alla tabella
// canDeleteRow -> se true aggiunge il bottone delete, quando viene cliccato viene lanciato l'evento "removeElementEvent"

export default {
  name: 'genericTable',
  components: { InfiniteLoading },
  props: ['headerLabels', 'elements', 'options', 'lengthPage', 'elementsDisabled'],
  methods: {
    visibleActionButtons(el) {
      if (!this.options.actionButtons) return [];

      return this.options.actionButtons.filter((button) => !button.elAttrVisibility || (el && el[button.elAttrVisibility]));
    },
    getElementForActionButton(element) {
      if (this.options.onlyIdForCustomButton) {
        const { id } = element;
        return { id: id };
      } else {
        return element;
      }
    },
    getElements(element) {
      return element ? Object.keys(element).filter((key) => key !== 'metadata' && !(this.options.metaAttributes || []).includes(key)) : [];
    },
    removeElement(element, index) {
      this.$emit('removeElementEvent', element, index);
    },
    openUrl(element, index) {
      this.$emit('openUrlEvent', element, index);
    },
    showUrl(element, index) {
      this.$emit('showUrlEvent', element, index);
    },
    notDisableElement(element) {
      return element && !this.elementsDisabled?.includes(element.id);
    },
    emitEvent({ element, index, type }) {
      this.$emit(`${type}Event`, element);
    },
    infiniteHandler($state) {
      this.options.handleUpdate().then((lengthResponse) => {
        if (lengthResponse === this.lengthPage) {
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
  },
  updated() {
    eventBus.$emit('genericTableUpdated');
  },
  watch: {
    'options.isResettableInfiniteLoader': function (newValue) {
      if (!newValue && this.$refs.infiniteLoading) {
        this.$refs.infiniteLoading.stateChanger.reset();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.button-table-generic {
  width: 165px !important;
  text-align: center;

  & .pulsante_comando {
    margin: 0 1px;
  }
}

.clickable {
  cursor: pointer;

  &:hover {
    color: #ef7b12;
  }
}

.no_border {
  border: none;
  outline: none;
}

.scroll1 {
  overflow-y: scroll;
}

.padding {
  padding: 0;
}
</style>
